
export default class BankAccountDepositRequestModel {
    public depositDate?: Date;
    public depositAmount: number = 0;
    public depositDescription: string = '';
}
